import { render, staticRenderFns } from "./BillsView.vue?vue&type=template&id=74be53d8"
import script from "./BillsView.vue?vue&type=script&lang=js"
export * from "./BillsView.vue?vue&type=script&lang=js"
import style0 from "./BillsView.vue?vue&type=style&index=0&id=74be53d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports